/**
 * PostcodeInput.
 */

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';

/**
 * Internal dependencies.
 */
import TextInput from '../TextInput';

function PostcodeInput({
	label,
	name,
	onChange,
	setCity,
	disabled = false,
	value,
	required,
	error = false,
}) {
	const handleInputChange = (value) => {
		onChange( value );

		if ( 4 === value.length ) {
			fetch( 'https://fraktguide.bring.no/fraktguide/api/postalCode.json?pnr=' + value )
				.then( response => response.json() )
				.then( data => {
					if ( true === data.valid ) {
						setCity( capitalize( data.result ) );
					}
				});
		}
	}

	function capitalize(word) {
		return word[0].toUpperCase() + word.slice(1).toLowerCase();
	}

	return (
		<TextInput
			id={name}
			name={name}
			minlength={4}
			maxlength={4}
			pattern="[0-9]+"
			value={value}
			label={label}
			required={required}
			onChange={(value) => handleInputChange(value)}
			disabled={disabled}
			error={error}
		/>
	)
}

export default PostcodeInput;
